import './Notification.css';
import { useEffect } from 'react';

function Notification({ message, type = 'success', onClose, duration = 2000 }) {
    useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [duration, onClose]);

    return (
        <div className={`notification notification-${type}`}>
            <div className="notification-content">
                <span className="notification-icon">
                    {type === 'success' ? '✓' : type === 'error' ? '✕' : 'ℹ'}
                </span>
                <span className="notification-message">{message}</span>
            </div>
            <button className="notification-close" onClick={onClose} title="Zavřít">
                ✕
            </button>
        </div>
    );
}

export default Notification;
